import React ,{useEffect,useState}from "react";
import { Routes, Route } from "react-router-dom";
import LandingPage from "./components/HomePage/LandingPage";
import './styles/globalStyle.css'
import OpenRoute from "./components/Auth/OpenRoute";
import PrivateRoute from "./components/Auth/PrivateRoute";
import RegistrationPage from "./components/Auth/Register/RegistrationPage";
import VerifyEmail from "./components/Auth/Register/VerifyEmail";
import GetStarted from "./components/Auth/GetStarted";
import LoginPage from "./components/Auth/Login/LoginPage";
import Success from "./components/Auth/Success";
import ForgetPassword from "./components/Auth/ForgetPassword";
import ChangePassword from "./components/Auth/ChangePassword";
import BusinessDashboardLayout from "./components/BusinessDashboard/common/BusinessDahboardLayout";
import BusinessDashBoard from "./components/BusinessDashboard/DashBoard";
import Team from "./components/BusinessDashboard/myTeams/Team";
import VerifyRoute from "./components/Auth/VerifyRoute";
import TeamRegister from "./components/Auth/TeamRegister";
import NotFoundPage from "./components/NotFound/NotFoundPage";
import JobPosting from "./components/BusinessDashboard/jobPostings/JobPosting";
import JobPostDetail from "./components/BusinessDashboard/jobPostings/JobPostDetail";
import RelevantCandidate from "./components/BusinessDashboard/jobPostings/RelevantCandidate";
import CandidateDetail from "./components/BusinessDashboard/jobPostings/CandidateDetail";
import Applicant from "./components/BusinessDashboard/jobPostings/Applicant";
import Resume from "./components/BusinessDashboard/Resumes/Resume";
import Notification from "./components/BusinessDashboard/Updates/Notification";
import Community from "./components/BusinessDashboard/Community/Community";
import SavedSearch from "./components/BusinessDashboard/savedSearch/SavedSearch";
import EmbeddedJobs from "./components/BusinessDashboard/EmbeddedJobs";
import Pricing from "./components/BusinessDashboard/Pricing/Pricing";
import EmbeddedJobView from "./components/BusinessDashboard/EmbeddedJobView";
import PermissionRoute from "./components/Auth/PermissionRoute";
import NotAuthorized from "./components/NotAuthorized/NotAuthorized";
import InterviewSchedule from "./components/BusinessDashboard/InterviewSchedule/InterviewSchedule";
import HelpDesk from "./components/BusinessDashboard/helpDesk/HelpDesk";
import Setting from "./components/BusinessDashboard/Setting/Setting";
import { useSelector } from "react-redux";
import LatestProductFeature from "./components/HomePage/LatestProductFeature";
import PricingPage from "./components/HomePage/PricingPage";
import SecruityPage from "./components/HomePage/SecruityPage";
import EthicalPage from "./components/HomePage/EthicalPage";
import AboutUs from "./components/HomePage/AboutUs";


function App() {

  const [isMobile, setIsMobile] = useState(false);
  const user=useSelector((state)=>state.profile.user)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (isMobile) {
    return (
      <div style={{ textAlign: "center", padding: "50px" }}>
        Looks like you're on a small screen! For the best results, please access this app on a desktop.
      </div>
    );
  }


  return (
    <div className="App">
      
      <Routes>
       <Route path="/jobs/:token" element={<EmbeddedJobs />} />
        <Route path="/view-carrer-page-job/:id/:company" element={<EmbeddedJobView/>} />
        <Route
          path="/get-started"
          element={
            <OpenRoute>
              <GetStarted />
            </OpenRoute>
          }
        />
        <Route path="/" element={<LandingPage />} />
         <Route path="/about-us" element={<AboutUs/>} />
         <Route path="/platform/latest-product-feature" element={<LatestProductFeature/>} />
           <Route path="/platform/pricing" element={<PricingPage/>} />
            <Route path="/platform/security" element={<SecruityPage/>} />
            <Route path="/platform/ethical-principles" element={<EthicalPage/>} />
        <Route path="/register"
          element={
            <OpenRoute>
              <RegistrationPage />
            </OpenRoute>
              
          }
        />
        <Route path="/register-team"
          element={
            <OpenRoute>
              <TeamRegister/>
            </OpenRoute>
          }
        />
        <Route path="/verify-email" element={
          <VerifyRoute>
            <VerifyEmail />
          </VerifyRoute>
        } />
        <Route path='/login' element={
          <OpenRoute>
            <LoginPage />
          </OpenRoute>
        } />
        <Route path='/registration-success' element={
          <VerifyRoute>
            <Success />
          </VerifyRoute>
        } />
        <Route path='/forget-password' element={
          <OpenRoute>
            <ForgetPassword />
          </OpenRoute>
        } />
        <Route path='/change-password' element={
          <OpenRoute>
            <ChangePassword />
          </OpenRoute>
        } />
        <Route
         path="/business-dashboard"
          element={
           <PrivateRoute allowedRoles={["business-admin", "recruiter", "hiring-manager","team-member"]}> 
              <BusinessDashboardLayout />
            </PrivateRoute>
           
          }
        >
          <Route index element={<BusinessDashBoard />} />
          <Route path='my-teams' element={
            <PermissionRoute>
            <Team />
            </PermissionRoute>
            } />
          <Route path='updates' element={
            <PermissionRoute>
            <Notification/>
            </PermissionRoute>
            } />
          <Route path='resume' element={
            <PermissionRoute>
            <Resume/>
          </PermissionRoute>}
             />
          <Route path='job-posting' element={
            <PermissionRoute>
            <JobPosting/>
            </PermissionRoute>
            } />
          <Route path='jobpost-detail' element={
            <JobPostDetail/>}/>
          <Route path='conversion' element={
            <PermissionRoute>
            <InterviewSchedule/>
            </PermissionRoute>
            } />
          <Route path='community' element={
            <PermissionRoute>
            <Community/>
            </PermissionRoute>
            } />
          <Route path='saved-searches' element={
            <PermissionRoute>
            <SavedSearch/>
            </PermissionRoute>
            }/>
          <Route path='subscription' element={
            <PermissionRoute>
            <Pricing/>
            </PermissionRoute>
            } />
          <Route path='settings' element={
            <PermissionRoute>
              <Setting/>
            </PermissionRoute>
            } />
          <Route path='help-desk' element={
            <PermissionRoute>
           <HelpDesk/>
            </PermissionRoute>} />
          <Route path='relevant-candidates' element={<RelevantCandidate/>}/>
           <Route path='applicants' element={<Applicant/>}/>
          <Route path="row-details" element={<CandidateDetail/>} />
        </Route>
        {/* <Route
         path="/hiring-dashboard"
          element={
            <PrivateRoute requiredRole="hiring-manager">
              <HiringLayout/>
            </PrivateRoute>
           
          }
        >
          <Route index element={<HiringDashBoard/>} />
        </Route>
        <Route
         path="/team-dashboard"
          element={
            <PrivateRoute requiredRole="team-member">
              <TeamMemberLayout/>
            </PrivateRoute>
           
          }
        >
          <Route index element={<TeamMemberDashboard/>} />
        </Route>
        <Route
         path="/recruiter-dashboard"
          element={
            <PrivateRoute PrivateRoute requiredRole="recruiter">
              <RecruiterLayout/>
            </PrivateRoute>
           
          }
        >
          <Route index element={<RecruiterDashBoard />} />
        </Route> */}
        <Route path='*' element={<NotFoundPage/>} />
         <Route path='/unauthorized' element={<NotAuthorized/>} />
      </Routes>
    </div>
  );
}

export default App;
